import Component from './campaign_filter.vue'
export default Component
